import React from "react";
import { useGetA2pPricingQuery } from "@/store/rest_api";

interface Props {
  soleProprietor: boolean;
  skipAutomaticSecVet: boolean;
  balance?: number;
}

export default function A2pPricingSummary({ soleProprietor, skipAutomaticSecVet, balance }: Props) {
  const { data: rates } = useGetA2pPricingQuery();
  if (!rates) {
    return null;
  }

  const lowTier = soleProprietor || skipAutomaticSecVet;
  const tierLabel = soleProprietor ? "Sole proprietor" : skipAutomaticSecVet ? "Low-volume" : "Standard";
  const brandFee = lowTier ? rates.brandLowVolume : rates.brandStandard;
  const vettingFee = rates.campaignVetting;
  const monthlyFee = soleProprietor
    ? rates.recurringSoleProprietor
    : skipAutomaticSecVet
      ? rates.recurringLowVolume
      : rates.recurringStandard;
  const oneTimeTotal = brandFee + vettingFee;
  const insufficient = balance != null && balance < oneTimeTotal;

  return (
    <div className="rounded-lg border bg-muted/40 p-4 space-y-2">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold">A2P 10DLC fees</h4>
        <span className="text-xs text-muted-foreground">{tierLabel} tier</span>
      </div>
      <div className="space-y-1 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Brand registration (one-time)</span>
          <span className="font-medium">${brandFee.toFixed(2)}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Campaign vetting (one-time)</span>
          <span className="font-medium">${vettingFee.toFixed(2)}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Campaign (monthly)</span>
          <span className="font-medium">${monthlyFee.toFixed(2)}/mo</span>
        </div>
      </div>
      {insufficient ? (
        <p className="text-xs text-destructive">
          Your balance (${balance!.toFixed(2)}) doesn't cover the one-time fees (${oneTimeTotal.toFixed(2)}). Top up before submitting.
        </p>
      ) : (
        <p className="text-xs text-muted-foreground">
          Charged to your account as each step is submitted. The monthly fee starts once your campaign is approved.
        </p>
      )}
    </div>
  );
}
